import { webSafeFonts } from '../../../components/Editor/constants';
const allowedFonts = Object.values(webSafeFonts);
export const cleanMark = (mark)=>{
    if (mark.type.name !== 'fontFamily') {
        return {};
    }
    if (allowedFonts.includes(mark.attrs['fontFamily'])) {
        return {
            fontFamily: mark.attrs['fontFamily']
        };
    }
    return {};
};

//# sourceMappingURL=fontFamily.js.map